import { jsx as t, jsxs as d } from "react/jsx-runtime";
import { classes as y } from "../../utils/styles.js";
import u from "../../assets/icons/ImagePlaceholder.js";
import { assetResponseIsEmpty as C } from "../../utils/utils.js";
import { CertificateIcons as x } from "../NutritionalAttributeHighlight/CertificateIcons.js";
import r from "./productcardsolo.module.js";
const E = ({ packagingMarkings: l, productName: c, gtin: h, images: e, href: a, ...p }) => {
  var i, n;
  const o = e == null ? void 0 : e[h], f = (i = o == null ? void 0 : o.primary) == null ? void 0 : i.url, s = ((n = o == null ? void 0 : o.additionals) == null ? void 0 : n.map((v) => v.url)) || [], N = f || (s == null ? void 0 : s[0]) || "", m = /* @__PURE__ */ t("div", { className: r.productcardsolo, ...p, children: /* @__PURE__ */ d("div", { className: r.body, children: [
    /* @__PURE__ */ d("div", { className: r.content, children: [
      /* @__PURE__ */ t("div", { className: r.imageWrapper, children: C(e) || !o ? /* @__PURE__ */ t(u, { className: r.placeholder }) : /* @__PURE__ */ t(
        "img",
        {
          className: r.image,
          "aria-hidden": "true",
          src: `${N}?h=80&auto=format`,
          alt: ""
        }
      ) }),
      /* @__PURE__ */ t(
        "div",
        {
          className: y([
            r.productname,
            ...l && l.split("; ").length >= 3 ? [r.withCert] : []
          ]),
          children: c
        }
      )
    ] }),
    /* @__PURE__ */ t(x, { packagingMarkings: l })
  ] }) });
  return a ? /* @__PURE__ */ t("a", { href: a, className: r.anchor, title: `${c}`, children: m }) : m;
};
export {
  E as ProductCardSolo
};
